import CardHeader, { CardHeaderTypeMap } from "@mui/material/CardHeader";
import { BaseProps } from "@mui/material/OverridableComponent";
import { withStyles, WithStyles } from "@mui/styles";
import { CardColors, cardColorTheme } from "assets/jss/mui-extras/cardCommon";
import classNames from "classnames";
import * as React from "react";

interface IProps {
    color: CardColors;
    center?: boolean;
    dense?: boolean;
}

type NewCardHeaderProps = Subtract<BaseProps<CardHeaderTypeMap>, "titleTypographyProps">;

type Props = IProps & NewCardHeaderProps & WithStyles<typeof cardColorTheme>;

const CardHeaderColor: React.FC<Props> = (props) => {
    const {
        classes,
        children,
        center,
        color,
        titleTypographyProps,
        dense,
        ...rest
    } = props;

    var titleTProps =
        titleTypographyProps
        ?? {
            align: center ? "center" : "inherit",
            variant: "h6"
        };

    return (
        <CardHeader
            classes={
                {
                    root: classes.headerRoot,
                    content: classNames(
                        classes[color + "HeaderContent"],
                        {
                            [classes.headerContent]: !dense,
                            [classes.headerContentDense]: dense,
                        }),
                    title: classes[color + "HeaderTitle"]
                }
            }

            titleTypographyProps={titleTProps}

            {...rest}
        >
            {children}
        </CardHeader >
    );
};

export default withStyles(cardColorTheme)(CardHeaderColor);
